import { Input } from '@braskai/ui-kit';
import { ControllerProps, FieldPath, FieldValues } from 'react-hook-form';

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../Form';

type FormInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<
  {
    label: string;
    disabled?: boolean;
    placeholder?: string;
  } & ControllerProps<TFieldValues, TName>,
  'render'
>;

export const FormInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  label,
  name,
  control,
  disabled,
  placeholder,
}: FormInputProps<TFieldValues, TName>) => {
  return (
    <FormField
      name={name}
      render={({ field, fieldState: { error } }) => (
        <FormItem flex={1}>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input disabled={disabled} error={!!error} placeholder={placeholder} {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
      control={control}
    />
  );
};
